import React from "react";
import PropTypes from "prop-types";
import { withFormsy } from "formsy-react";
import Toggle from "react-toggle";

import { Row, Col } from "react-bootstrap";
import { IoMoonOutline, IoMoon } from "react-icons/io5";

import "react-toggle/style.css";

const CustomToggle = ({
  name,
  label,
  value,
  required,
  disabled,
  onChange,
  iconChecked,
  iconUnChecked,
  checked
}) => {
  const fieldLabel = required && !disabled ? `${label} *` : label;

  return (
    <Row className="form-group">
      {label && (
        <Col sm={12}>
          <label
            className={`control-label ${!label ? "hidden" : ""}`}
            htmlFor={name}
            style={{ textTransform: "uppercase" }}
          >
            {fieldLabel}
          </label>
        </Col>
      )}
      <Col sm={12}>
        <Toggle
          name={name}
          onChange={onChange}
          disabled={disabled}
          checked={checked}
          value={value}
          icons={{
            checked: iconChecked,
            unchecked: iconUnChecked
          }}
        />
      </Col>
    </Row>
  );
};

CustomToggle.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  iconChecked: PropTypes.object,
  iconUnChecked: PropTypes.object,
  checked: PropTypes.bool
};

CustomToggle.defaultProps = {
  iconChecked: <IoMoon />,
  iconUnChecked: <IoMoonOutline />
};

export default withFormsy(CustomToggle);
